/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:eb32ea3e-eca1-4d80-abab-3dede1195ccc",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_luSPBVGWF",
    "aws_user_pools_web_client_id": "25lvshrklq7od8urn8cpnjahsa",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://55u71vf2ie.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "jcap-starfishmaster-master",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
